import { render, staticRenderFns } from "./record-index.vue?vue&type=template&id=0a6a464b&"
import script from "./record-index.vue?vue&type=script&lang=js&"
export * from "./record-index.vue?vue&type=script&lang=js&"
import style0 from "./record-index.vue?vue&type=style&index=0&id=0a6a464b&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a6a464b')) {
      api.createRecord('0a6a464b', component.options)
    } else {
      api.reload('0a6a464b', component.options)
    }
    module.hot.accept("./record-index.vue?vue&type=template&id=0a6a464b&", function () {
      api.rerender('0a6a464b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warehouses/record-index.vue"
export default component.exports